import { createStore } from 'owa-satcheljs';
import type { Win32IconStore } from './schema/Win32IconStore';

export const getStore: () => Win32IconStore = createStore('Win32Icon', {
    areSmallIconsRegistered: false,
    areDefaultIconsRegistered: false,
    areLargeIconsRegistered: false,
});
